import { Clock } from "lucide-react";

const ComingSoonPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-red-50 to-orange-100 flex items-center justify-center px-4 py-12 font-quicksand">
      <div className="max-w-3xl w-full text-center">
        {/* Icon */}
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <div className="w-20 h-20 bg-gradient-to-br from-[#FF4523] to-orange-500 rounded-2xl flex items-center justify-center shadow-lg">
              <Clock className="w-10 h-10 text-white" />
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="space-y-3 lg:space-y-6">
          <div className="inline-block px-4 py-2 bg-[#FF4523] bg-opacity-10 border border-[#FF4523] border-opacity-30 rounded-full text-[#FF4523] text-sm font-semibold mb-4">
            COMING SOON
          </div>

          <div className="text-4xl md:text-6xl font-bold text-[#031722] font-poppins flex flex-col leading-relaxed tracking-wide sm:gap-y-1 lg:gap-y-2">
            <div>Something Amazing</div>
            <div className="text-transparent  bg-clip-text bg-gradient-to-r from-[#FF4523] to-orange-500">
              Is On The Way
            </div>
          </div>

          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            We're crafting an exceptional real estate experience for you. This
            feature is under construction and will be launching soon.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
// import { Clock } from "lucide-react";

// const ComingSoonPage = () => {
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-[#000433] via-[#031722] to-slate-900 flex items-center justify-center px-4 py-12 font-quicksand relative overflow-hidden">
//       {/* Animated Background Elements */}
//       <div className="absolute inset-0 overflow-hidden">
//         <div className="absolute top-20 left-10 w-72 h-72 bg-[#8051FA] opacity-10 rounded-full blur-3xl animate-pulse"></div>
//         <div
//           className="absolute bottom-20 right-10 w-96 h-96 bg-[#FF4523] opacity-10 rounded-full blur-3xl animate-pulse"
//           style={{ animationDelay: "1s" }}
//         ></div>
//       </div>

//       <div className="max-w-3xl w-full text-center relative z-10">
//         {/* Icon */}
//         <div className="mb-8 flex justify-center">
//           <div className="relative">
//             <div className="w-24 h-24 bg-gradient-to-br from-[#8051FA] to-[#FF4523] rounded-2xl flex items-center justify-center shadow-2xl">
//               <Clock className="w-12 h-12 text-white" />
//             </div>
//             <div className="absolute inset-0 bg-gradient-to-br from-[#8051FA] to-[#FF4523] rounded-2xl blur-xl opacity-50"></div>
//           </div>
//         </div>

//         {/* Main Content */}
//         <div className="space-y-6">
//           <div className="inline-block px-4 py-2 bg-[#8051FA] bg-opacity-20 backdrop-blur-sm border border-[#8051FA] border-opacity-30 rounded-full text-[#8051FA] text-sm font-semibold mb-4">
//             COMING SOON
//           </div>

//           <h1 className="text-4xl md:text-6xl font-bold text-white font-poppins leading-tight">
//             Something Amazing
//             <br />
//             <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#8051FA] to-[#FF4523]">
//               Is On The Way
//             </span>
//           </h1>

//           <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
//             We're crafting an exceptional real estate experience for you. This
//             feature is under construction and will be launching soon.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ComingSoonPage;
